import { defineComponent as _defineComponent } from 'vue'
import Button from '../button/Button.vue'
import Modal from '@/components/Modal/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    title: null,
    subtitle: null,
    items: null,
    loading: { type: Boolean }
  },
  emits: ["cancel", "delete"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'cancel'): void
	(event: 'delete'): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, Button, Modal }
}

})